// 初始化Flickity轮播
document.addEventListener("DOMContentLoaded", function () {
  // 轮询查找元素并移动到指定位置
  let timer = setInterval(function () {
    console.log("轮询查找元素并移动到指定位置");
    // 循环获取所有.shopify-section元素，并找找元素id包含"image_with_reviews_FNCp9Q"的元素
    let targetSection = null;
    const allSections = document.querySelectorAll(".shopify-section");

    for (let i = 0; i < allSections.length; i++) {
      const section = allSections[i];
      if (section.id && section.id.indexOf("image_with_reviews_FNCp9Q") !== -1) {
        targetSection = section;
        console.log("找到目标元素:", section.id);
        break;
      }
    }

    const sections = targetSection;
    const joinPhotographers = document.querySelector(".join-photographers");
    const joinPhotographersTitle = document.querySelector(".join-photographers-title");

    if (sections && joinPhotographers && joinPhotographersTitle) {
      // 找到目标元素，将其移动到join-photographers-title下方
      joinPhotographersTitle.insertAdjacentElement("afterend", sections);
      clearInterval(timer); // 清除定时器
    }
  }, 500);

  // 设置10秒超时
  setTimeout(function () {
    clearInterval(timer);
  }, 10000);
});

// 图片替换函数
function replaceWithGif(device) {
  const placeholder = document.getElementById(device + "-placeholder");
  const gif = document.getElementById(device + "-gif");

  if (placeholder && gif) {
    // 隐藏占位图片，显示GIF
    placeholder.style.display = "none";
    gif.style.display = "block";
  }
}

// 注册 Alpine.js 组件
document.addEventListener("alpine:init", () => {
  // 锚点滚动组件
  Alpine.data("anchorScroll", () => ({
    scrollToSection(sectionId) {
      // 获取目标元素
      const targetElement = document.getElementById(sectionId);

      if (!targetElement) return;

      const bar = document.querySelector(".shopify-section--announcement-bar");
      const header = document.querySelector(".shopify-section--header");
      let offsetHeight = 0;
      if (bar) offsetHeight += bar.offsetHeight;
      if (header) offsetHeight += header.offsetHeight;
      targetElement.style.scrollMarginTop = offsetHeight + 20 + "px";

      // 使用 scrollIntoView 滚动到目标元素
      // 通过 CSS scroll-margin-top 控制元素距离顶部的高度
      targetElement.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    },
  }));

  // 主组件
  Alpine.data("kateDay2025", () => ({
    // 主组件的状态和方法
    init() {
      this.faqInitToggle();
    },

    // FAQ 功能初始化
    faqInitToggle() {
      const faqQuestions = document.querySelectorAll(".faq-question");

      faqQuestions.forEach((question) => {
        question.addEventListener("click", function () {
          const isExpanded = this.getAttribute("aria-expanded") === "true";
          const targetId = this.getAttribute("aria-controls");
          const target = document.getElementById(targetId);

          // Toggle aria-expanded
          this.setAttribute("aria-expanded", !isExpanded);

          // Toggle collapsible content
          if (target) {
            if (isExpanded) {
              target.removeAttribute("open");
            } else {
              target.setAttribute("open", "");
            }
          }
        });
      });
    },
  }));

  // 层叠卡片轮播组件方法
  const cascadingCardCarousel = {
    // 获取卡片样式
    getCardStyle(card) {
      let style = "";

      if (card.previewOpacity !== undefined) {
        style += `opacity: ${card.previewOpacity};`;
      }

      if (card.previewTransform !== undefined) {
        style += `transform: ${card.previewTransform};`;
      }

      return style;
    },

    // 处理卡片点击事件
    handleCardClick(clickedCard) {
      if (this.isRearranging || this.isDragging) return;

      // 如果卡片有链接，则跳转到链接
      if (clickedCard.link && clickedCard.link.trim() !== "") {
        window.open(clickedCard.link, "_blank");
        return;
      }

      // 如果没有链接，则执行原来的逻辑
      if (clickedCard.position === 0) return;
      this.bringCardToTop(clickedCard);
    },

    // 将指定卡片移动到最顶部
    bringCardToTop(targetCard) {
      if (this.isRearranging) return;

      const targetPosition = targetCard.position;
      this.isRearranging = true;

      this.cards.forEach((card) => {
        card.isMovingForward = true;

        if (card === targetCard) {
          card.position = 0;
        } else if (card.position < targetPosition) {
          card.position = card.position + 1;
        }
      });

      setTimeout(() => {
        this.isRearranging = false;
        this.cards.forEach((card) => {
          card.isMovingForward = false;
        });
      }, 500);
    },

    // 开始拖拽
    startDrag(event) {
      if (this.isRearranging) return;

      const target = event.target;
      // 如果点击的是图片，找到包含它的card__item
      const cardElement = target.classList.contains("card__item") ? target : target.closest(".card__item");

      if (!cardElement) return;

      const isTopCard = cardElement.classList.contains("position-0");

      if (!isTopCard) {
        return;
      }

      this.isDragging = true;
      const clientX = event.type.includes("touch") ? event.touches[0].clientX : event.clientX;
      this.dragStartX = clientX;
      event.preventDefault();
    },

    // 更新拖拽
    updateDrag(event) {
      if (!this.isDragging || this.isRearranging) return;

      const clientX = event.type.includes("touch") ? event.touches[0].clientX : event.clientX;
      const dragDistance = clientX - this.dragStartX;
      const dragDistanceAbs = Math.abs(dragDistance);
      const dragRatio = Math.min(dragDistanceAbs / this.dragThreshold, 1);

      if (dragRatio >= 1) {
        this.isDragging = false;
        this.slideOutTopCard(dragDistance > 0 ? "right" : "left");
        event.preventDefault();
        return;
      }

      if (dragRatio > 0) {
        const topCard = this.cards.find((card) => card.position === 0);
        if (topCard) {
          const opacity = Math.max(0.6, 1 - dragRatio * 0.4);
          topCard.previewOpacity = opacity;

          const translateX = dragDistance > 0 ? dragRatio * 150 : -dragRatio * 150;
          topCard.previewTransform = `translateX(${translateX}px) scale(${1 - dragRatio * 0.1})`;

          const rotation = dragDistance > 0 ? dragRatio * 10 : -dragRatio * 10;
          topCard.previewTransform += ` rotate(${rotation}deg)`;
        }
      }

      event.preventDefault();
    },

    // 结束拖拽
    endDrag(event) {
      if (!this.isDragging) return;

      this.isDragging = false;
      const clientX = event.type.includes("touch") ? event.changedTouches[0].clientX : event.clientX;
      const dragDistance = clientX - this.dragStartX;
      const dragDistanceAbs = Math.abs(dragDistance);
      const dragRatio = dragDistanceAbs / this.dragThreshold;

      if (dragRatio < 1) {
        this.resetProgressDirectly();
      }

      event.preventDefault();
    },

    // 直接重置进度
    resetProgressDirectly() {
      this.cards.forEach((card) => {
        if (card.previewOpacity !== undefined) {
          delete card.previewOpacity;
        }
        if (card.previewTransform !== undefined) {
          delete card.previewTransform;
        }
        if (card.isBouncing !== undefined) {
          delete card.isBouncing;
        }
      });
    },

    // 滑动顶部卡片
    slideOutTopCard(direction = "left") {
      if (this.isRearranging) return;

      this.cards.forEach((card) => {
        if (card.previewOpacity !== undefined) {
          delete card.previewOpacity;
        }
        if (card.previewTransform !== undefined) {
          delete card.previewTransform;
        }
        if (card.isBouncing !== undefined) {
          delete card.isBouncing;
        }
      });

      const topCard = this.cards.find((card) => card.position === 0);
      if (!topCard) return;

      topCard.slideDirection = direction;
      topCard.isSlidingOut = true;

      setTimeout(() => {
        topCard.isSlidingOut = false;
        this.isRearranging = true;

        if (direction === "right") {
          this.cards.forEach((card) => {
            if (card.position > 0) {
              card.isMovingForward = true;
              card.position = card.position - 1;
            }
          });
          topCard.position = 2;
        } else {
          const lastCard = this.cards.find((card) => card.position === 2);
          if (lastCard) {
            lastCard.position = 0;
            lastCard.isMovingForward = true;

            this.cards.forEach((card) => {
              if (card !== lastCard && card !== topCard) {
                card.position = card.position + 1;
                card.isMovingForward = true;
              }
            });

            topCard.position = 1;
          }
        }

        setTimeout(() => {
          this.isRearranging = false;
          this.cards.forEach((card) => {
            card.isMovingForward = false;
          });

          let reappearingCard;
          if (direction === "right") {
            reappearingCard = topCard;
            reappearingCard.slideDirection = "right";
          } else {
            reappearingCard = this.cards.find((card) => card.position === 0);
            if (reappearingCard) {
              reappearingCard.slideDirection = "left";
            }
          }

          if (reappearingCard) {
            reappearingCard.isReappearing = true;
          }

          setTimeout(() => {
            if (reappearingCard) {
              reappearingCard.isReappearing = false;
            }
          }, 600);
        }, 500);
      }, 600);
    },
  };

  // 层叠卡片轮播子组件
  Alpine.data("cascadingCardCarousel_1", (config) => {
    // 从传入的配置中获取卡片数据和置顶图片ID
    const tempCards = config.cards || [];
    const topImageId = config.topImageId || 1;

    // 根据选择的置顶图片重新排列
    const topCardIndex = tempCards.findIndex((card) => card.id === topImageId);
    if (topCardIndex > 0) {
      const topCard = tempCards.splice(topCardIndex, 1)[0];
      tempCards.unshift(topCard);
    }

    // 设置position
    tempCards.forEach((card, index) => {
      card.position = index;
    });

    return {
      isRearranging: false,
      isDragging: false,
      dragStartX: 0,
      dragThreshold: 100,
      cards: tempCards,
      ...cascadingCardCarousel,
    };
  });

  // 层叠卡片轮播子组件
  Alpine.data("cascadingCardCarousel_2", (config) => {
    // 从传入的配置中获取卡片数据和置顶图片ID
    const tempCards = config.cards || [];
    const topImageId = config.topImageId || 1;

    // 根据选择的置顶图片重新排列
    const topCardIndex = tempCards.findIndex((card) => card.id === topImageId);
    if (topCardIndex > 0) {
      const topCard = tempCards.splice(topCardIndex, 1)[0];
      tempCards.unshift(topCard);
    }

    // 设置position
    tempCards.forEach((card, index) => {
      card.position = index;
    });

    return {
      isRearranging: false,
      isDragging: false,
      dragStartX: 0,
      dragThreshold: 100,
      cards: tempCards,
      ...cascadingCardCarousel,
    };
  });

  // Install Web App 模态框组件
  Alpine.data("installWebAppModal", () => ({
    isModalVisible: false,
    deviceType: "unknown", // 'android', 'ios', 'unknown'

    // 检测设备类型
    detectDevice() {
      try {
        const userAgent = navigator.userAgent.toLowerCase();

        // 检测Android设备
        if (userAgent.includes("android")) {
          this.deviceType = "android";
        }
        // 检测iOS设备
        else if (/iphone|ipad|ipod/.test(userAgent) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1)) {
          this.deviceType = "ios";
        }
        // 如果检测失败，显示所有教程
        else {
          this.deviceType = "unknown";
        }
      } catch (error) {
        console.warn("设备检测失败:", error);
        this.deviceType = "unknown";
      }
    },

    // 判断是否应该显示Android教程
    showAndroidTutorial() {
      return this.deviceType === "android" || this.deviceType === "unknown";
    },

    // 判断是否应该显示iOS教程
    showIosTutorial() {
      return this.deviceType === "ios" || this.deviceType === "unknown";
    },

    showModal() {
      this.isModalVisible = true;
      // 防止背景滚动
      document.body.style.overflow = "hidden";
    },

    hideModal(event = null) {
      // 如果点击的是遮罩层（不是模态框内容），则关闭模态框
      if (event && event.target.classList.contains("install-web-app-modal")) {
        this.isModalVisible = false;
        document.body.style.overflow = "";
      } else if (!event) {
        // 直接调用关闭
        this.isModalVisible = false;
        document.body.style.overflow = "";
      }
    },

    init() {
      // 检测设备类型
      this.detectDevice();

      // 监听ESC键关闭模态框
      this.$el.addEventListener("keydown", (e) => {
        if (e.key === "Escape" && this.isModalVisible) {
          this.hideModal();
        }
      });
    },
  }));

  // 用户反馈轮播组件 - 优化版，支持多图片显示
  Alpine.data("userFeedbackCarousel", (config) => ({
    images: config && config.images ? config.images.filter((img) => img) : [], // 过滤掉空值

    currentIndex: 0,

    // 模态框相关状态
    showModal: false,
    modalIndex: 0,
    imageScale: 1,
    isDragging: false,
    dragStart: { x: 0, y: 0 },
    imagePosition: { x: 0, y: 0 },

    // 计算最后一页能展示多少张图片
    getLastPageItemCount() {
      const track = this.$refs.track;
      if (!track || this.images.length === 0) return 1;

      const carouselItems = track.querySelectorAll(".carousel-item");
      if (carouselItems.length === 0) return 1;

      const containerWidth = track.clientWidth;
      const paddingLeft = parseFloat(getComputedStyle(track).paddingLeft) || 0;
      const paddingRight = parseFloat(getComputedStyle(track).paddingRight) || 0;
      const gap = parseFloat(getComputedStyle(track).gap) || 16;
      const availableWidth = containerWidth - paddingLeft - paddingRight;

      // 从最后一张图片开始向前计算，看能放下多少张
      let totalWidth = 0;
      let lastPageCount = 0;

      for (let i = carouselItems.length - 1; i >= 0; i--) {
        const item = carouselItems[i];
        const itemWidth = item.offsetWidth;
        const itemTotalWidth = itemWidth + (lastPageCount > 0 ? gap : 0);

        if (totalWidth + itemTotalWidth <= availableWidth) {
          totalWidth += itemTotalWidth;
          lastPageCount++;
        } else {
          break;
        }
      }

      return Math.max(1, lastPageCount);
    },

    // 计算最大页面索引
    get maxPageIndex() {
      if (this.images.length === 0) return 0;
      const lastPageCount = this.getLastPageItemCount();
      return Math.max(0, this.images.length - lastPageCount);
    },

    // 计算当前图片的滚动位置
    getScrollPosition() {
      const track = this.$refs.track;
      if (!track) return 0;

      // 获取所有实际的图片项元素（排除template元素）
      const carouselItems = track.querySelectorAll(".carousel-item");
      if (!carouselItems[this.currentIndex]) return 0;

      const item = carouselItems[this.currentIndex];
      const paddingLeft = parseFloat(getComputedStyle(track).paddingLeft) || 0;

      // 如果是最后一张图片，确保它完全可见
      if (this.currentIndex === this.maxPageIndex) {
        const containerWidth = track.clientWidth;
        const maxScrollLeft = track.scrollWidth - containerWidth;
        return Math.max(0, maxScrollLeft);
      }

      return item.offsetLeft - paddingLeft;
    },

    // 检查是否可以向前切换
    get canGoPrev() {
      return this.currentIndex > 0;
    },

    // 检查是否可以向后切换
    get canGoNext() {
      return this.currentIndex < this.maxPageIndex;
    },

    // 切换到上一张图片
    goPrev() {
      if (this.canGoPrev) {
        this.currentIndex--;
        this.scrollToCurrent();
      }
    },

    // 切换到下一张图片
    goNext() {
      if (this.canGoNext) {
        this.currentIndex++;
        this.scrollToCurrent();
      }
    },

    // 滚动到当前图片位置
    scrollToCurrent() {
      const track = this.$refs.track;
      if (!track) return;

      const targetPosition = this.getScrollPosition();
      track.scrollTo({
        left: targetPosition,
        behavior: "smooth",
      });
    },

    // 处理窗口大小变化
    handleResize() {
      // 确保当前索引不超出新的最大值
      if (this.currentIndex > this.maxPageIndex) {
        this.currentIndex = this.maxPageIndex;
      }
    },

    // 模态框相关方法
    openModal(index) {
      this.modalIndex = index;
      this.showModal = true;
      this.imageScale = 1;
      this.imagePosition = { x: 0, y: 0 };
      document.body.style.overflow = "hidden"; // 防止背景滚动
    },

    closeModal() {
      this.showModal = false;
      document.body.style.overflow = ""; // 恢复背景滚动
    },

    // 图片缩放功能
    zoomIn() {
      this.imageScale = Math.min(this.imageScale * 1.2, 5);
    },

    zoomOut() {
      this.imageScale = Math.max(this.imageScale / 1.2, 0.1);
    },

    resetZoom() {
      this.imageScale = 1;
      this.imagePosition = { x: 0, y: 0 };
    },

    // 鼠标滚轮缩放
    handleWheel(event) {
      event.preventDefault();
      const delta = event.deltaY > 0 ? 0.9 : 1.1;
      this.imageScale = Math.max(0.1, Math.min(5, this.imageScale * delta));
    },

    // 拖拽功能
    startDrag(event) {
      if (this.imageScale > 1) {
        this.isDragging = true;
        this.dragStart = { x: event.clientX, y: event.clientY };
        event.preventDefault();
      }
    },

    drag(event) {
      if (this.isDragging && this.imageScale > 1) {
        const deltaX = event.clientX - this.dragStart.x;
        const deltaY = event.clientY - this.dragStart.y;
        this.imagePosition.x += deltaX;
        this.imagePosition.y += deltaY;
        this.dragStart = { x: event.clientX, y: event.clientY };
      }
    },

    endDrag() {
      this.isDragging = false;
    },

    // 模态框内图片导航
    prevImage() {
      if (this.modalIndex > 0) {
        this.modalIndex--;
        this.resetZoom();
      }
    },

    nextImage() {
      if (this.modalIndex < this.images.length - 1) {
        this.modalIndex++;
        this.resetZoom();
      }
    },

    init() {
      console.log("User Feedback Carousel initialized with", this.images.length, "images");

      // 初始化时滚动到第一张图片
      this.$nextTick(() => {
        this.scrollToCurrent();
      });

      // 监听窗口大小变化
      window.addEventListener("resize", () => {
        this.handleResize();
      });

      // 监听键盘事件
      document.addEventListener("keydown", (event) => {
        if (this.showModal) {
          switch (event.key) {
            case "Escape":
              this.closeModal();
              break;
            case "ArrowLeft":
              this.prevImage();
              break;
            case "ArrowRight":
              this.nextImage();
              break;
            case "+":
            case "=":
              this.zoomIn();
              break;
            case "-":
              this.zoomOut();
              break;
            case "0":
              this.resetZoom();
              break;
          }
        }
      });
    },
  }));

  // Featured Collections 加载器组件
  Alpine.data("featuredCollectionsLoader", () => ({
    targetElementId: "shopify-section-template--17480572141664__featured_collections_aMU94g",
    pollInterval: null,
    maxAttempts: 20, // 最多查询10秒，每500ms一次，所以是20次
    currentAttempts: 0,
    isPolling: false, // 添加轮询状态标志
    isCompleted: false, // 添加完成状态标志

    init() {
      this.startPolling();
    },

    startPolling() {
      // 防止重复启动轮询
      if (this.isPolling || this.isCompleted) {
        return;
      }

      this.isPolling = true;
      console.log("开始轮询查找目标元素");

      // 使用箭头函数确保 this 上下文正确
      this.pollInterval = setInterval(() => {
        // 检查是否已经完成，防止重复执行
        if (this.isCompleted) {
          this.stopPolling();
          return;
        }

        this.currentAttempts++;

        // 如果超过最大尝试次数，停止轮询
        if (this.currentAttempts > this.maxAttempts) {
          console.warn("10秒内未找到目标元素，停止轮询");
          this.stopPolling();
          return;
        }

        const targetElement = document.getElementById(this.targetElementId);

        if (targetElement) {
          console.log("找到目标元素，开始移动");
          this.isCompleted = true; // 标记为已完成
          this.moveElement(targetElement);
          this.stopPolling();
          return; // 确保在找到元素后立即返回
        } else {
          console.log(`第 ${this.currentAttempts} 次尝试查找元素 ${this.targetElementId}`);
        }
      }, 500); // 每500ms轮询一次
    },

    stopPolling() {
      if (this.pollInterval) {
        clearInterval(this.pollInterval);
        this.pollInterval = null;
      }
      this.isPolling = false;
      console.log("轮询已停止");
    },

    moveElement(targetElement) {
      try {
        // 获取目标容器
        const container = this.$el;

        if (!container) {
          console.error("未找到容器元素");
          return;
        }
        // 修改 VIEW ALL 在新窗口打开
        const viewAllLink = targetElement.querySelector("a.button.button--primary");
        if (viewAllLink) {
          viewAllLink.setAttribute("target", "_blank");
          viewAllLink.setAttribute("rel", "noopener noreferrer");
          console.log("VIEW ALL链接已设置为在新窗口打开");
        }

        // 将目标元素移动到容器内
        container.appendChild(targetElement);

        console.log("元素移动成功");
      } catch (error) {
        console.error("移动元素时出错:", error);
      }
    },
  }));
});
